import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});
export const styles = StyleSheet.create({
  header: {
    padding: 35,
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    '@media max-width: 400': {
      fontSize: 18,
    },
  },
  logo: {
    width: 'auto',
    height: 28,
  },
  accountLogo: {
    width: 100,
    height: 50,
  },
  hand: {
    width: 'auto',
    height: 40,
    top: 12,
    left: 36,
    position: 'relative',
  },
  location: {
    fontSize: 8,
    '@media max-width: 400': {
      fontSize: 8,
    },
  },
  link: {
    textDecoration: 'none',
    fontSize: 8,
    marginRight: 3,
    '@media max-width: 400': {
      fontSize: 7,
    },
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '3px',
  },
  companyDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingRight: 40,
    paddingLeft: 40,
    paddingTop: 15,
    paddingBottom: 40,
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  companyContact: {
    display: 'flex',
    flexDirection: 'row',
  },
  companyWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '3px',
  },
  content: {
    fontSize: 12,
    paddingLeft: 40,
    paddingRight: 40,
  },
  tableRow: {
    flexDirection: 'row',
    minHeight: 30,
    borderColor: '#000',
    borderBottomWidth: 1,
  },
  tableHeader: {
    borderBottomWidth: 2,
    height: 35,
    fontSize: 12,
    paddingTop: 6,
    paddingRight: 10,
    fontFamily: 'Lato',
    fontWeight: 'bold',
  },
  tableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 10,
    paddingTop: 8,
    paddingBottom: 5,
    paddingRight: 10,
    wordBreak: 'break-word',
  },

  tableTitle: {
    paddingBottom: 28,
    fontSize: 14,
    textAlign: 'center',
  },
  buttonContainer: {
    position: 'absolute',
    left: '43%',
    bottom: 30,
  },
  button: {
    textDecoration: 'none',
    color: 'white',
    paddingTop: 15,
    paddingRight: 25,
    paddingLeft: 25,
    paddingBottom: 8,
    width: 180,
    height: 54,
    alignItems: 'center',
    position: 'relative',
    top: 0,
    left: 0,
    zIndex: 1,
    fontSize: 16,
  },
  boldText: {
    fontWeight: 'bold',
    fontFamily: 'Lato',
    fontSize: 8,
  },
  footerButtonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    backgroundColor: '#d3d3d3',
    marginTop: 30,
    padding: 20,
    width: '78%',
  },
  buttonsWrapperText: {
    textAlign: 'center',
    color: '#019ee0',
    fontSize: 20,
    fontWeight: 900,
    
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
  },
  footerButton: {
    textDecoration: 'none',
    paddingTop: 15,
    paddingRight: 25,
    paddingLeft: 25,
    paddingBottom: 15,
    backgroundColor: '#019ee0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
  },
  buttonTitleText: {
    color: 'white',
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 900,
  },
  buttonLinkText: {
    color: 'white',
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 900,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 3,
    alignItems: 'center',
    justifyContent: 'center',
  },
  footerTitle: {
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingHorizontal: 2,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    width: '100%',
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: 'transparent',
    height: 60,
  },
  footerColumn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: '100%',
    gap: 4,
    paddingHorizontal: 2,
    paddingVertical: 10,
    height: 60,
    marginHorizontal: 4,
  },
  footerMiddleItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
    color: 'white',
    fontSize: 12,
    fontFamily: 'Lato',
    textAlign: 'center',
    width: '100%',
  },
  logoTitle: {
    width: 80,
    height: 'auto',
    objectFit: 'cover',
  },
  portfolioLogo: {
    width: 85,
    height: 27,
    objectFit: 'cotain',
  },
  icon: {
    width: 6,
    height: 6,
    objectFit: 'cover',
  },
});
